export const ReasonForNoEdit = {
  NoPermission: 'NO_PERMISSION',
  CanNotChange: 'CAN_NOT_CHANGE',
} as const;

export type ReasonForNoEditType =
  (typeof ReasonForNoEdit)[keyof typeof ReasonForNoEdit];
